var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FDDB70;}\r\n\t.st1{fill:none;stroke:#030000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,5.6c-21.3,11.6-22,22-22.7,38.5s10.5,40.7,45.2,38.6c34.7-2.1,38.8-31,38.9-47.5 C87.2,15.3,52.7-9.3,25.6,5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.1,4.5c-1.1,1.9-6.6,4.8-9.9,6.3c-4.3,1.9-7.8,4.4-10,8.6s-4.2,9-5,16.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.5,3.8c1.2,2.2,10.8,6.7,13.1,7.7c4.5,2,7.3,4.9,8.8,8.3c1.6,3.6,2.4,7.5,2.1,11.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.9,27.6c3.9,2.9,9.5,3.4,13.9,1.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,30.8C24,37.3,24,44.5,26.1,51.1c0.3,1,0.7,2,0.8,3.1c0,1.3-0.5,2.6-1,3.8c-3.4,9.3-3.5,19.7,0,29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,27.4c1.9,1.6,4.5,2.4,7,2.2c2.5-0.2,4.9-1.4,6.5-3.4c0.5-0.5,0.9-1.2,0.7-1.9c-0.2-0.7-1.1-1.2-1.5-0.7 c-0.3,0.3-0.3,0.9-0.2,1.3c0.5,2.3,2,3.7,2.9,7.6c2.1,8.6,0.6,13.8-0.4,22.5c-0.3,2.6,0.6,5.1,0.9,7.6c0.8,7.2,0.1,14.6-2.2,21.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,52.4c10.1,5.2,25.3,5,35.5,0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,66c0,0-2.3,1.6-5.9,1.1c-0.8-0.1-1.6-0.4-2.1-1S41.4,64.5,42,64c0.8-0.7,2.1,0,2.5,1s0.1,2.1-0.2,3.1 c-1.5,5.2-3.1,10.3-4.6,15.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,70c0.9,5.5,2.6,10.8,5.2,15.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,8.4c2.6,2.3,5.9,3.9,9.3,3.8c3.4,0,6.9-1.8,8.6-4.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,29.9c3.8-1.1,7.7-2.2,11.5-3.2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.1,30.6c-3.1-1.5-6-3.3-8.8-5.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndo);
export default __webpack_public_path__ + "static/media/endo.281cb6c7d8f13d7d35023de3c647ded7.svg";
export { ForwardRef as ReactComponent };